import { render, staticRenderFns } from "./WarehouseProducts.vue?vue&type=template&id=2c3c8b40&scoped=true&"
import script from "./WarehouseProducts.vue?vue&type=script&lang=js&"
export * from "./WarehouseProducts.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseProducts.vue?vue&type=style&index=0&id=2c3c8b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c8b40",
  null
  
)

export default component.exports